import { AxiosRequestConfig, AxiosError } from 'axios';
import axios from './config';
import { RESTDataMapper } from '../utils';
import { ShowMessageCalBack } from '../components';
import { NavigateFunction } from 'react-router';
import URLs from '../pages/URLs';

interface ErrorResponseData {
  message?: string;
}
export const fetchData = async <T = unknown>(
  config: AxiosRequestConfig,
  showMessage: ShowMessageCalBack,
  navigate: NavigateFunction,
): Promise<{ data?: T }> => {
  try {
    const response = await axios({
      ...config,
      ['data']: config.data && RESTDataMapper(config.data),
    });
    return { data: RESTDataMapper(response.data, true) as T };
  } catch (err) {
    const axiosError = err as AxiosError;

    if (axiosError.response?.status === 403) {
      navigate(URLs.Login);
      return;
    }

    showMessage(
      axiosError.response?.data
        ? (axiosError.response.data as ErrorResponseData).message ||
            axiosError.response.data?.toString()
        : axiosError.message,
      'error',
    );
  }
};
